@if (loading) {
<section class="case-study-detail animate-fade-in-up">
    <div class="case-study-detail__shell">
        <div class="case-study-detail__status">Loading case study...</div>
    </div>
</section>
} @else if (caseStudy; as activeCaseStudy) {
<section class="case-study-detail animate-fade-in-up">
    <div class="case-study-detail__shell">
        <div class="case-study-detail__header">
            <button class="case-study-detail__back" type="button" (click)="navigateBack()">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
                </svg>
                <span>Case Studies Return</span>
            </button>

            <section class="case-study-hero">
                <div class="case-study-hero__glow" aria-hidden="true"></div>
                <div class="case-study-hero__content">
                    <div class="case-study-hero__tag-row">
                        <span class="case-study-hero__tag">{{ activeCaseStudy.tag }}</span>
                    </div>
                    <h1 class="case-study-hero__title">{{ activeCaseStudy.title }}</h1>
                    <div class="case-study-hero__meta">
                        <div>
                            <p class="case-study-hero__label">Client</p>
                            <p class="case-study-hero__value">{{ activeCaseStudy.clientName }}</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="case-study-detail__content">
            <div class="case-study-summary">
                <div class="case-study-summary__block">
                    <h2 class="case-study-summary__heading">Executive Summary</h2>
                    <p class="case-study-summary__overview">{{ activeCaseStudy.executiveSummary }}</p>
                </div>

                @if (activeCaseStudy.keyOutcomes.length > 0) {
                <div class="case-study-summary__block">
                    <h2 class="case-study-summary__heading">Key Outcomes</h2>
                    <ul class="case-study-outcomes" aria-label="Key outcomes">
                        @for (outcome of activeCaseStudy.keyOutcomes; track outcome) {
                        <li class="case-study-outcomes__item">
                            <span class="case-study-outcomes__icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24">
                                    <path d="M5 13l4 4L19 7"></path>
                                </svg>
                            </span>
                            <span class="case-study-outcomes__text">{{ outcome }}</span>
                        </li>
                        }
                    </ul>
                </div>
                }
            </div>

            @if (renderedBody) {
            <section class="case-study-richtext" [innerHTML]="renderedBody" aria-label="Case study body"></section>
            }
        </div>
    </div>
</section>
} @else {
<section class="case-study-detail case-study-detail--fallback animate-fade-in-up">
    <div class="case-study-detail__fallback">
        <h1 class="case-study-detail__fallback-code">404</h1>
        <p class="case-study-detail__fallback-copy">{{ errorMessage || 'This case study is currently unavailable.' }}
        </p>
        <button class="case-study-detail__fallback-action" type="button" (click)="navigateBack()">
            Return to Case Studies
        </button>
    </div>
</section>
}